'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'link';
var width = 576;
var height = 512;
var aliases = [128279,"chain"];
var unicode = 'f0c1';
var svgPathData = 'M427.5 88c-21.4 0-42.2 6.9-59.3 19.4-11.4-11.7-24.4-22.1-38.4-30.7 27-23.6 61.7-36.7 97.7-36.7 82 0 148.5 66.5 148.5 148.5 0 39.4-15.6 77.1-43.5 105l-79.1 79.1c-27.8 27.8-65.6 43.5-105 43.5-82 0-148.5-66.5-148.5-148.5 0-17.9 3.2-35.5 9.4-51.9 4.6-12.4 18.5-18.7 30.9-14.1S259 220 254.4 232.4c-4.2 11.1-6.4 23-6.4 35.2 0 55.5 45 100.5 100.5 100.5 26.6 0 52.2-10.6 71-29.4l79.1-79.1C517.4 240.6 528 215.1 528 188.5 528 133 483 88 427.5 88zm-200 56c-26.6 0-52.2 10.6-71 29.4L77.4 252.5c-18.8 18.8-29.4 44.4-29.4 71 0 55.5 45 100.5 100.5 100.5 21.4 0 42.2-6.9 59.3-19.4 11.4 11.8 24.4 22.1 38.4 30.7-27 23.6-61.7 36.7-97.7 36.7-82 0-148.5-66.5-148.5-148.5 0-39.4 15.6-77.1 43.5-105l79.1-79.1c27.8-27.8 65.6-43.5 105-43.5 82 0 148.5 66.5 148.5 148.5 0 17.9-3.2 35.5-9.4 51.9-4.6 12.4-18.5 18.7-30.9 14.1S317 292 321.6 279.6c4.2-11.1 6.4-23 6.4-35.1 0-55.5-45-100.5-100.5-100.5z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faLink = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;